import {ApplicationRef, Component, ViewChild} from '@angular/core';

import {
    AlertController, App, FabContainer, ItemSliding, List, ModalController, NavController, ToastController,
    LoadingController, Refresher, Events
} from 'ionic-angular';

/*
  To learn how to use third party libs in an
  Ionic app check out our docs here: http://ionicframework.com/docs/v2/resources/third-party-libs/
*/
// import moment from 'moment';

import { ConferenceData } from '../../../providers/conference-data';
import { UserData } from '../../../providers/user-data';
import {MissionsData} from "../../../providers/missions-data";

import { SessionDetailPage } from '../../session-detail/session-detail';
import { ScheduleFilterPage } from '../../schedule-filter/schedule-filter';
import {MissionsMapPage} from "../missions-map/missions-map";
import {MissionDetailPage} from "../mission-detail/mission-detail";
import {MissionsFilterPage} from "../missions-filter/missions-filter";

import {AngularFireDatabase} from "angularfire2/database";



import {LocationSelectForm} from "../../utils/location-select/location-select";
import {Geolocation} from "@ionic-native/geolocation";
import {Observable} from "rxjs/Observable";
import {LoginPage} from "../../login/login";
import {MissionsPostulatePage} from "../missions-postulate/missions-postulate";
import {MissionsCandidateDetailPage} from "../missions-candidate/missions-candidate-detail/missions-candidate-detail";


declare var google: any;

@Component({
    selector: 'page-missions-list',
    templateUrl: 'missions-list.html'
})
export class MissionsListPage {
    // the list is a child of the schedule page
    // @ViewChild('scheduleList') gets a reference to the list
    // with the variable #scheduleList, `read: List` tells it to return
    // the List and not a reference to the element
    @ViewChild('scheduleList', { read: List }) scheduleList: List;
    @ViewChild('listContent') listContent;


    userInfos: any;
    sessionRef: any;
    userRef: any;
    listeners:boolean = false;
    pageLoadable:boolean = false;
    dayIndex = 0;
    queryText = '';
    segment = 'list';
    locationSelectModal: any;
    locationSelectModalInited: boolean = false;
    excludeTracks: any = [];
    shownSessions: any = [];
    groups: any = [];
    confDate: string;
    searchFilters: any;
    missions:any;
    allMissions:any;
    locationAsked:boolean=false;

    userCandidates:any;

    geolocationRunning:boolean=false;
    geolocationTimer:any=false;
    sortOptions: any = false;
    inited: any = false;
    loading: any = false;
    order: any = false;
    currently_loading: any = false;

    page = 0;
    page_number = 1;
    page_size = 20;

    constructor(
        public alertCtrl: AlertController,
        public app: App,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,
        public navCtrl: NavController,
        public toastCtrl: ToastController,
        public confData: ConferenceData,
        public userData: UserData,
        public missionsData: MissionsData,
        public afDatabase: AngularFireDatabase,
        private geolocation: Geolocation,
        public events: Events,
        public application: ApplicationRef
    ) {
        this.sortOptions = {
            title: 'Ordre d\'affichage des missions'
        };
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state && !this.currently_loading)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading && this.currently_loading){
            //this.loadingCtrl.dismiss();
            this.loading.dismiss();
            this.currently_loading = false;
        }
    }

    updateSchedule(log = "from unknow") {

        this.app.setTitle('Schedule');
        this.searchFilters = this.userData.get('searchFilters');
        if(this.searchFilters && this.searchFilters.order)
            this.order = this.searchFilters.order;
        else
            this.order = 'date';

        this.searchFilters.order = this.order = 'location';
        //console.log('LIST');
        this.missionsData.getList(this.searchFilters,this.queryText).subscribe((data: any) => {
            this.allMissions=data;
            this.page_number = Math.ceil(this.allMissions.length/this.page_size);
            //this.missions = this.allMissions.slice(0,this.page*this.page_size);
            this.page=0;
            //console.log('PAGE');
            this.addMissionPage();
            this.shownSessions = this.missionsData.listLength;
            this.setLoading(false);
            //console.log('PAGEND');
        });

    }
    scrollEnd(){
        //console.log('scroll End');
        this.addMissionPage();
    }
    addMissionPage() {
        if (this.page < this.page_size) {
            /*var that = this;
            setTimeout(function () {


            }, 2000);*/
            var that = this;
            that.page++;
            //console.log('GOTO '+that.page);
            that.gotoPage(that.page);
            //console.log('GOTO '+that.page);
        }

        if (this.page >= this.page_number) this.pageLoadable = false;
        if (this.page < this.page_number) this.pageLoadable = true;

    }
    gotoPage(i)
    {

        var mission_log = Date.now();
        var that = this;
        var filtered_missions = [];
        for(var t=0;t<that.allMissions.length;t++)
        {
            if(!that.allMissions[t].hide)filtered_missions.push(that.allMissions[t]);
        }

        that.page_number = Math.ceil(filtered_missions.length/that.page_size);
        that.missions = filtered_missions.slice(0, that.page * that.page_size);

        //console.log(that.page , that.page_number);
        if (that.page >= that.page_number) that.pageLoadable = false;
        if (that.page < that.page_number) that.pageLoadable = true;
        //console.log(that.missions);
        //this.content.resize();
        console.log('SLICE',mission_log-Date.now());
        that.application.tick();

    }


    postulate(mission)
    {
        let modal = this.modalCtrl.create(MissionsPostulatePage, {missionId: mission.id});
        modal.present();

        modal.onWillDismiss((data: any[]) => {
            this.goToMissionDetail(mission)
        });
    }
    seeCandidate(missionData)
    {
        this.navCtrl.push(MissionsCandidateDetailPage, { missionId: missionData.id, name: missionData.name });
    }
    goToMissionDetail(missionData: any) {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.push(MissionDetailPage, { missionId: missionData.id, name: missionData.name });
    }

    addFavorite(slidingItem: ItemSliding, sessionData: any) {

        if (this.userData.hasFavorite(sessionData.name)) {
            // woops, they already favorited it! What shall we do!?
            // prompt them to remove it
            this.removeFavorite(slidingItem, sessionData, 'Favorite already added');
        } else {
            // remember this session as a user favorite
            this.userData.addFavorite(sessionData.name);

            // create an alert instance
            let alert = this.alertCtrl.create({
                title: 'Favorite Added',
                buttons: [{
                    text: 'OK',
                    handler: () => {
                        // close the sliding item
                        slidingItem.close();
                    }
                }]
            });
            // now present the alert on top of all other content
            alert.present();
        }

    }

    removeFavorite(slidingItem: ItemSliding, sessionData: any, title: string) {
        let alert = this.alertCtrl.create({
            title: title,
            message: 'Would you like to remove this session from your favorites?',
            buttons: [
                {
                    text: 'Cancel',
                    handler: () => {
                        // they clicked the cancel button, do not remove the session
                        // close the sliding item and hide the option buttons
                        slidingItem.close();
                    }
                },
                {
                    text: 'Remove',
                    handler: () => {
                        // they want to remove this session from their favorites
                        this.userData.removeFavorite(sessionData.name);
                        this.updateSchedule();

                        // close the sliding item and hide the option buttons
                        slidingItem.close();
                    }
                }
            ]
        });
        // now present the alert on top of all other content
        alert.present();
    }

    openSocial(network: string, fab: FabContainer) {
        let loading = this.loadingCtrl.create({
            content: `Posting to ${network}`,
            duration: (Math.random() * 1000) + 500
        });
        loading.onWillDismiss(() => {
            fab.close();
        });
        loading.present();
    }

    doRefresh(refresher: Refresher) {
        this.updateSchedule("from refresher");

            // simulate a network request that would take longer
            // than just pulling from out local json file
            setTimeout(() => {
                refresher.complete();

                const toast = this.toastCtrl.create({
                    message: 'Les missions ont été mises à jour.',
                    duration: 3000
                });
                toast.present();

            }, 1000);

    }


    presentFilter() {
        let modal = this.modalCtrl.create(MissionsFilterPage, this.excludeTracks);
        modal.present();

        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.searchFilters = this.userData.get('searchFilters');
                this.updateSchedule("from modal");
            }
        });

    }
    ionViewDidLoad() {

    }
    ionViewWillUnload() {
        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }
    ionViewDidEnter(){
        this.getUserInfos();
        /*var content = document.querySelector('ion-content');
        content.addEventListener('scrollEnd', () => console.log('scroll end'));*/
    }
    ngAfterViewInit(){}
    ionViewDidLeave(ev){}
    getUserInfos() {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed)
        {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session != null) {
                    that.userRef = that.userData.load().subscribe(user => {

                        var that = this;
                        that.searchFilters = that.userData.get('searchFilters');
                        if (that.searchFilters.location && !that.searchFilters.location.enabled && !that.locationAsked) {
                            that.setLoading(false);
                            that.launchLocate();

                        }
                        else {
                            if (!that.inited) {
                                that.inited = true;
                                that.setLoading(true);
                                that.updateSchedule("from user ref");
                            }
                        }
                        that.userCandidates = that.userData.get('missionCandidates');

                    });
                }
            });
            that.listenToLoginEvents();
        }

    }
    listenToLoginEvents() {
        if(!this.listeners)
        {
            this.listeners = true;
            this.events.subscribe('user:logout', () => {
            });
        }
    }
    launchLocate(){
        this.geoLocate();
    }
    askSearchFilters()
    {
        if(!this.locationAsked)
        {
            this.locationAsked = true;
            let prompt = this.alertCtrl.create({
                enableBackdropDismiss:false,
                title: 'Emplacement de la recherche',
                message: "Pour vous proposer des missions nous devons savoir dans quelle région vous vous trouvez.",
                buttons: [
                    {
                        text: 'Me localiser',
                        handler: data => {
                            this.locationAsked = false;
                            this.geoLocate();

                        }
                    },
                    {
                        text: 'Chercher autour d\'une adresse',
                        handler: data => {
                            this.locationAsked = false;
                            this.chooseLocation();

                        }
                    }
                ]
            });
            prompt.present();
        }
    }
    geoLocate()
    {
        if(!this.locationAsked) {
            var that = this;
            this.locationAsked = true;
            this.setLoading(true, 'Géolocalisation en cours ...');
            this.geolocationTimer = setTimeout(
                function(){
                    that.geolocationError();
                },5000
            );
            this.geolocationRunning = true;
            this.geolocation.getCurrentPosition().then((resp) => {
                if(this.geolocationRunning)
                {
                    this.searchFilters.location.lat = resp.coords.latitude;
                    this.searchFilters.location.lng = resp.coords.longitude;
                    this.searchFilters.location.enabled = true;
                    this.searchFilters.location.mode = "position";
                    var geocoder = new google.maps.Geocoder;
                    var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
                    geocoder.geocode({'location': latlng}, function (results, status) {
                        if(that.geolocationRunning) {
                            clearTimeout(that.geolocationTimer);
                            if (status === 'OK') {
                                if (results[0]) {
                                    that.searchFilters.location.address = results[0].formatted_address;
                                } else {
                                }
                                that.userData.set('searchFilters/location', that.searchFilters.location);
                            } else {
                            }
                            that.locationAsked = false;
                            that.setLoading(false);
                            that.updateSchedule("from geocode");
                            that.geolocationRunning = false;
                        }
                    });
                }

            }).catch((error) => {
                that.geolocationError();
            });
        }
    }
    geolocationError()
    {
        this.geolocationRunning = false;
        const toast = this.toastCtrl.create({
            message: 'La géolocalisation a échoué. ' +
            'Il est possible que vous ayez refusé d\'être géolocalisé ou que les paramètres de votre appareil ne le permette pas.' +
            'N\'hésitez pas à choisir le mode de recherche par adresse.',
            showCloseButton: true,
            cssClass: 'danger',
            closeButtonText: 'Ok',
            dismissOnPageChange: true,
            duration: 5000
        });
        toast.present();
        //this.searchFilters.location.mode = 'address';
        this.setLoading(false);
        this.locationAsked = false;
        this.askSearchFilters();
    }
    chooseLocation()
    {
        var that = this;
        this.locationSelectModal = this.modalCtrl.create(LocationSelectForm, { mode: "address" });

        this.locationSelectModal.onDidDismiss(place => {
            let geometry = place.geometry;
            let locationData = {};
            if ((geometry) !== undefined) {

                locationData = {
                    lng: geometry.location.lng(),
                    lat: geometry.location.lat(),
                    mode: "address",
                    address:place.formatted_address,
                    enabled: true,
                    distance:50
                };
                this.userData.update('searchFilters','location',locationData);
                //this.userData.getUserDbReference('searchFilters').update({'location':locationData});
                //this.userData.getUserDbReference('searchFilters').update({'filter':'new'});

                this.updateSchedule("from location select");


            }

        });

        this.locationSelectModal.present();
    }
    gotoMap() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsMapPage);
    }
    gotoList() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsListPage);
    }
    changeOrder(v1,v2){
        //this.searchFilters.order=event;
        console.log(v1,v2);
        if(this.searchFilters) {
            if(v1 != this.searchFilters.order) {
                this.userData.set('searchFilters/order', v1);
                this.updateSchedule("from change order");
            }
        }
        else
        {
            //this.getUserInfos();
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-list/missions-list.ts